import { useAudioTime } from "@aircall/tractor";

import { mergeTranscriptEntries } from "@/helpers/aiActions/aiActions.helpers";
import { TranscriptEntry } from "@/helpers/aiActions/aiActions.helpers.decl";
import { useAutoScrollOnce } from "@/hooks/useAutoScrollOnce/useAutoScrollOnce";
import { useCall } from "@/hooks/useCall/useCall";
import { useCallAIActions } from "@/hooks/useCallAIActions/useCallAIActions";
import { UtteranceType } from "@/states/call/utterances/utterances.utility.decl";
import { TranscriptionAIActionItem } from "../TranscriptionAIActionItem/TranscriptionAIActionItem";
import { TranscriptItem } from "../TranscriptionItem/TranscriptionItem";
import * as S from "./TrascriptionList.styled";

type ContentProps = {
  entries: TranscriptEntry[];
};

function Content({ entries }: ContentProps) {
  const { currentTime } = useAudioTime();

  // Allows us to display the name of the speaker only once, when you have multiple utterances from the same speaker in a row.
  const shouldDisplayName = (utterance: UtteranceType, position: number) => {
    const previousEntry = entries[position - 1];

    return (
      previousEntry?.kind !== "utterance" ||
      previousEntry.utterance.channel !== utterance.channel
    );
  };

  return (
    <>
      {entries.map((entry, position) =>
        entry.kind === "aiAction" ? (
          <TranscriptionAIActionItem
            key={entry.action.id}
            action={entry.action}
          />
        ) : (
          <TranscriptItem
            key={entry.index}
            displayName={shouldDisplayName(entry.utterance, position)}
            currentTime={currentTime}
            active
            utterance={entry.utterance}
            index={entry.index}
          />
        )
      )}
    </>
  );
}

export function TranscriptionList() {
  const { call } = useCall();
  const aiActions = useCallAIActions();

  // Auto scroll when we have some matches
  useAutoScrollOnce();

  if (!call?.utterances?.length && aiActions.length === 0) {
    return null;
  }

  return (
    <S.Container data-test="utterances-wrapper">
      <Content
        entries={mergeTranscriptEntries(call?.utterances ?? [], aiActions)}
      />
    </S.Container>
  );
}
